import PageComponent from "../../components/page/page_comp"
import NotFoundComp from "./components/not_found_comp"
import PageV2Component from "../../components/page_v2/page_v2_comp";

const NotFoundPage = () => {
    return <NotFoundComp/>
}

export default NotFoundPage